export default "__VITE_ASSET__C_4H70js__"